import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, HStack, VStack, Text, Button, IconButton, Divider, Link
} from '@chakra-ui/react';
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { 
    MdFeaturedPlayList, MdClose, MdDashboard, MdDashboardCustomize, MdImportExport, MdOutlineImportExport, MdSettings,
    MdOutlineViewDay 
} from 'react-icons/md';
import { FaBars, FaCog } from 'react-icons/fa';
import "../../styles/index.scss";

function LeftPanel({ }) {
    const locations = useLocation();
    const navigate = useNavigate();
    const [ isShowLeftPanel, setIsShowLeftPanel ] = useState(false);
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);

    return (
        <Flex flexDirection="column" bg="gray.300">
            <Flex justify="flex-start" position="fixed" left={0} top={0} display={{ base: isShowLeftPanel ? "none" : "inherit", md: "none", lg: "none" }}>
                <IconButton variant="ghost" _hover="transparent" icon={<FaBars />} 
                    onClick={() => {
                        setIsShowLeftPanel(!isShowLeftPanel)
                    }}
                />
            </Flex>
           
            <Flex flexDirection="column" minW="200px" h="100%" justify="space-between"
                borderWidth={1} borderColor="gray.700" display={{ base: (isShowLeftPanel ? "inherit" : "none"), md: "inherit", lg: "inherit" }}
            >   
                <VStack>
                    <HStack>
                        <IconButton variant="ghost" _hover="transparent" icon={<MdClose />} 
                            display={{ base: (isShowLeftPanel ? "inherit" : "none"), md: "none", lg: "none" }}
                            onClick={() => {
                                setIsShowLeftPanel(!isShowLeftPanel)
                            }}
                        />
                    </HStack>

                    <Flex flexDirection="column" mt={2}>
                        <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                            className={(locations.pathname === "/") || (locations.pathname === "/") ? 'highlight-button' : ''} 
                            onClick={() => navigate("/")}
                        >
                            <MdDashboard /> Dashboard
                        </Button>
                        <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                            className={(locations.pathname === "/compare-money") ? 'highlight-button' : ''} 
                            onClick={() => navigate("/compare-money")}
                        >
                            <MdDashboardCustomize /> Dashboard doanh thu
                        </Button>
                        {/* <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/import-datas" ? 'highlight-button' : ''} 
                            onClick={() => navigate("/import-datas")}
                        >
                           <MdImportExport /> Import dữ liệu
                        </Button> */}
                        <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/import-datas-v2" ? 'highlight-button' : ''} 
                            onClick={() => navigate("/import-datas-v2")}
                        >
                           <MdOutlineImportExport /> Import dữ liệu (mới)
                        </Button>
                        <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/order-management" ? 'highlight-button' : ''} 
                            onClick={() => navigate("/order-management")}
                        >
                           <MdOutlineViewDay /> Quản lý đơn hàng
                        </Button>
                        <Button variant="ghost" height={8} _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/admin" ? 'highlight-button' : ''} 
                            onClick={() => navigate("/admin")}
                        >
                           <MdSettings /> Admin
                        </Button>
                    </Flex>
                </VStack>
            </Flex>
        </Flex>
    )
}

export default LeftPanel;